import React, { useState } from 'react';
import { Button, Typography, Dialog, DialogActions, DialogContent, DialogTitle, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import Supervisor from '../../../Image/Supervisor.png';

const BntMoreSupervisor = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // Função auxiliar para criar os boxes de informação
  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0,
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            overflow: 'hidden',
            width: '100%',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          OBC Supervisor Module        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh', // scroll vertical quando necessário
          }}
        >
          {/* Imagem do Supervisor */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 4 }}>
            <img
              src={Supervisor}
              alt="Supervisor Computer"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>

          {/* Grid com 2 colunas */}
          <Grid container spacing={3}>
            {/* Coluna 1 */}
            <Grid item xs={6}>
              <InfoBox title="Processing Power">
                • RISC-V Soft CPU <br />
                • FPGA Programmable Logic 450k System Logic Cells
              </InfoBox>

              <InfoBox title="Input Data Rate">
                • Space Wire up to 100 Mbps <br />
                • Space Fiber up to 6.25 Gbit/s <br />
                • 1Mbps CAN
              </InfoBox>

              <InfoBox title="Front Panel Connectivity">
                • 1x Cross-Strapped RS-422 UART <br />
                • 6x RS-422 UART <br />
                • 1x JTAG
              </InfoBox>

              <InfoBox title="Front Panel Interfaces">
                • 4x Digital Inputs 3.3V <br />
                • 4x Digital Source Outputs 3.3V <br />
                • 4x Analog Inputs 5V
              </InfoBox>

              <InfoBox title="Memory">
                • 2GB DDR4 (16 bit) <br />
                • 32GB NAND Flash (SLC) with Triple Modular Redundant Architecture
              </InfoBox>
            </Grid>

            {/* Coluna 2 */}
            <Grid item xs={6}>
              <InfoBox title="Back Plane Interfaces">
                • 4x Space Wire Mesh <br />
                • 4x Space Fibre Dual Lane in Star configuration <br />
                • Custom Processor interface for boot memory interface <br />
                • Custom Supervisor interface (redundancy) <br />
                • ADHA Standard P2 <br />
                • ADHA Standard P1 with CAN, I2C, Sync and GPIOs <br />
                • ADHA Backplane controller with PSON, RST, HMS and Sync signals
              </InfoBox>

              <InfoBox title="Power Budgets">
                • Input Voltage: 12V <br />
                • Maximum Consumption: 10W
              </InfoBox>

              <InfoBox title="Mechanical Budgets">
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: 350 grams <br />
                • Thermal: Δt 15,42°C at the processor junction
              </InfoBox>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntMoreSupervisor;
